// extracted by mini-css-extract-plugin
export default {"root":"Serch_root__MuriZ","input":"Serch_input__qGklt","icon":"Serch_icon__gMbDp","clearIcon":"Serch_clearIcon__p87Nj"};